import * as types from 'store/types';
import produce from 'immer';

import { LOCALSTORAGE_USER } from 'helpers';

const user = JSON.parse(localStorage.getItem(LOCALSTORAGE_USER));

const INITIAL_STATE = {
	authenticate: user || null,
	isError: false,
	isAuthenticated: user ? user.isAuthenticated : false,
	signOut: {
		error: false,
		loading: false
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ------------ Authenticate user ------------
			case types.AUTH_USER_LOADING:
				return { ...INITIAL_STATE };

			case types.AUTH_USER_SUCCESS:
				draft.authenticate = {
					...action.payload,
					...draft.authenticate
				};
				draft.isError = false;
				draft.isAuthenticated = true;
				return;

			case types.AUTH_USER_ERROR:
				draft.isError = action.payload;
				return;

			// ------------ Sign out ------------
			case types.AUTH_SIGN_OUT_LOADING:
				draft.signOut.loading = true;
				return;

			case types.AUTH_SIGN_OUT_SUCCESS:
				return { ...INITIAL_STATE };

			case types.AUTH_SIGN_OUT_ERROR:
				draft.signOut.loading = false;
				draft.signOut.error = true;
				return;

			default:
				return state;
		}
	});
